import React from 'react'
import DOMPurify from 'dompurify'

interface IDangerousSetInnerHTML {
  content: string
}

export const DangerousSetInnerHTML = ({ content }: IDangerousSetInnerHTML) => {
  const cleanHTML = DOMPurify.sanitize(content)
  return <div dangerouslySetInnerHTML={{ __html: cleanHTML }} />
}
